import { render } from "./BlockList.vue?vue&type=template&id=5877299e&ts=true"
import script from "./BlockList.vue?vue&type=script&lang=ts"
export * from "./BlockList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__